module.exports = __webpack_public_path__ + "ac7eb2a661f4c7506367a8a04be45bed.svg";